module.exports = __webpack_public_path__ + "img/bio_b_500.ab7db90f.png";